<script setup lang="ts">
import {AlertCircle, CheckCircle} from "utruckin-icons";
import {useAlert} from "@/utils/alert";

const {alerts, remove} = useAlert()
</script>

<template>
  <div class="c-cu-alert-container">
    <TransitionGroup name="toast">
      <div
          v-for="(alert, index) in alerts"
          :key="alert.id"
          class="c-cu-alert"
          :style="{
          top: `${index * 12}px`,
          right: '12px',
          zIndex: 100 + index
        }"
          @click="remove(alert.id)"
      >
        <div class="body">
          <div class="body__icon"
               :class="alert.type">
            <CheckCircle v-if="alert.type == 'success'" :size="24"/>
            <AlertCircle v-else :size="24"/>
          </div>
          <div class="body__label">
            {{ alert.message }}
          </div>
        </div>
      </div>
    </TransitionGroup>
  </div>
</template>

<style scoped lang="scss">
.c-cu-alert-container {
  position: fixed;
  right: 16px;
  top: 16px;
  z-index: 99999;
}

.c-cu-alert {
  position: absolute;
  min-width: 200px;
  max-width: 500px;
  background: var(--color-background);
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 1000;

  .body {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 4px 12px 4px 4px;

    &__icon {
      background: var(--color-red);
      color: white;
      width: 44px;
      height: 44px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 14px;

      &.success {
        background: var(--color-green);
      }

      &.warning {
        background: var(--color-orange);
      }

      &.error {
        background: var(--color-red);
      }
    }

    &__label {
      font-weight: 600;
      white-space: nowrap;
      color: var(--color-label);
    }
  }
}

/* ENTER ANIMATION */
.toast-enter-from {
  opacity: 0;
  transform: translateY(60px);
}

.toast-enter-active {
  transition: all 0.35s cubic-bezier(0.22, 1, 0.36, 1);
}

.toast-enter-to {
  opacity: 1;
  transform: translateY(0);
}

/* LEAVE ANIMATION */
.toast-leave-active {
  transition: opacity 0.4s ease;
}

.toast-leave-from {
  opacity: 1;
}

.toast-leave-to {
  opacity: 0;
}
</style>